import React, { Component} from 'react';

export default function withAuthLayout(WrappedComponent, data={}) {
    return class extends Component {
        constructor (props) {
            super(props);
            this.state = {
                ...data,
            };
        }
        
        render () {
            return (
              <div className="auth page-width">
                <div className="content-width">
                    <div className="auth-content">
                    <WrappedComponent {...this.props}/>
                    </div>
                    
                </div>
              </div>  
            );
        }
    }
}